module.exports = __webpack_public_path__ + "static/media/logoBaaam.e56b7c32.png";